module.exports = __webpack_public_path__ + "static/media/HUN_bekescsaba_cimer.b29a51e0.svg";